import type { InvestmentMix } from '../../investment';

/**
 * The per-board Run-vs-Change bar for the portfolio roll-up (#435). A compact
 * two-tone split by card count — the same tones as the board metrics strip
 * (`--inv-change` petrol / `--inv-run` steel-grey) — so a vertical scan sorts
 * investment-heavy boards from pure-run ones. The caption names the dominant side;
 * the exact counts are on hover (title), keeping the column narrow. A board with no
 * cards to classify shows a plain dash, never a 0% bar.
 */
export default function MixBar({ mix }: { mix: InvestmentMix }) {
  if (!mix.label) return <span className="pf-mix none" aria-hidden="true">—</span>;
  const dominant = mix.changePct >= mix.runPct ? `${mix.changePct}% Change` : `${mix.runPct}% Run`;
  const title = `${mix.change} Change · ${mix.run} Run (by card count)`;
  return (
    <div className="pf-mix" title={title}>
      <span className="pf-mix-bar" aria-hidden="true">
        {mix.change > 0 && <span className="pf-mix-seg is-change" style={{ width: `${mix.changePct}%` }} />}
        {mix.run > 0 && <span className="pf-mix-seg is-run" style={{ width: `${mix.runPct}%` }} />}
      </span>
      <span className="pf-mix-cap">{dominant}</span>
    </div>
  );
}
